package com.appsyde.shared.modules.ticket.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class TicketHistoryResponseDto(
    val items: List<TicketHistoryItemDto>
)

@Serializable
data class TicketHistoryItemDto(
    val id: String,
    val direction: String,
    val sentAtMs: Long,
    val providerMessageId: String? = null,
    val summary: String? = null
)

@Serializable
data class TicketOriginalHistoryResponseDto(
    val items: List<TicketOriginalHistoryItemDto>
)

@Serializable
data class TicketOriginalHistoryItemDto(
    val id: String,
    val direction: String,
    val sentAtMs: Long,
    val providerMessageId: String? = null,
    val from: String? = null,
    val to: String? = null,
    val subject: String? = null,
    val mimeType: String? = null,
    val body: String? = null,
    val snippet: String? = null,
    val error: String? = null
)
